export default __webpack_public_path__ + "static/505-64dd87b6ef4cb61191858cd26b53cb6d.gif";